import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

export const AccordionHeaderText = styled(Typography)(({ theme }) => ({
  '&.MuiTypography-root': {
    textTransform: 'uppercase',
    color: theme.palette.primary.main,
    fontSize: '14px',
  },
}));
